import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { careLinksReducer } from './care-links.reducer';
import { CareLinksEffects } from './care-links.effects';

@NgModule({
  imports: [
    StoreModule.forFeature('careLinks', careLinksReducer),
    EffectsModule.forFeature([CareLinksEffects])
  ]
})
export class CareLinksStateModule {}
